import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/admin/formulations";
const  resource_single = "/admin/formulation";
export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getListWithElasticSearch(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/formulation-elasticsearch?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  getListOfFormulationNoPagination(is_dev_required = 1) {
    return Repository.get(`/admin/formulation-list?is_paginate=0&is_dev_required=${is_dev_required}`)
  },
  create(payload) {
    return Repository.post(`${resource}`, payload)
  },
  createWithItems(payload) {
    return Repository.post('/admin/formulation-with-items', payload)
  },
  createReplicate(payload,id) {
    return Repository.post(`${resource_single}/${id}/replicate`, payload)
  },
  details(id) {
    return Repository.get(`${resource}/${id}`)
  },
  getActivityLog(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${resource}/activity_log/${id}?paginate=${pagination}&page=${pageNumber}`)
  },
  getStaffFormulationLogs(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/log/staff/formulation/${id}?paginate=${pagination}&page=${pageNumber}&per_page=${pagination}`)
  },
  getFormulationsRawMaterial(search, id, selected_fg_ids, selected_rm_ids) {
    return Repository.get(`${resource}/raw_material_list?filter[search]=${search}&formulation_id=${id}&selected_fg_ids=${selected_fg_ids}&selected_rm_ids=${selected_rm_ids}`)
  },
  formulaCalculate(payload) {
    return Repository.post(`${resource}-calculate`, payload)
  },
  updateFormulations(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  },
  updateFormulationsItems(id, payload) {
    return Repository.put(`${resource_single}/${id}/items`, payload)
  },
  updateFormulationsNote(id, payload) {
    return Repository.put(`${resource_single}/${id}/note`, payload)
  },
  updateFormulationsApplications(id, payload) {
    return Repository.put(`${resource_single}/${id}/application`, payload)
  },
  getProductionCodes() {
    return Repository.get(`${resource}/production_codes`)
  },
  approveFormulations(id, payload) {
    return Repository.put(`${resource}/moderation-prod/${id}`, payload)
  },
  suspendFormulations(id) {
    return Repository.put(`${resource}/moderation-suspend/${id}`)
  },
  archiveFormulations(id) {
    return Repository.put(`${resource}/moderation-archive/${id}`)
  },
  unArchiveFormulations(id) {
    return Repository.put(`${resource}/moderation-unarchive/${id}`)
  },
  reInstateFormulations(id) {
    return Repository.put(`${resource}/moderation-re-instate/${id}`)
  },
  changeToDevFormulations(id) {
    return Repository.put(`${resource}/moderation-dev/${id}`)
  },
  qaSubmissionFormulations(id) {
    return Repository.put(`${resource}/moderation-qa-submission/${id}`)
  },
  qaApproveFormulations(id, payload) {
    return Repository.put(`${resource}/moderation-qa-approve/${id}`, payload)
  },
  qaRejectFormulations(id, payload) {
    return Repository.put(`${resource}/moderation-qa-reject/${id}`, payload)
  },
  createFormulaQcTest(payload) {
    return Repository.post(`${resource}/q_c_tests`, payload)
  },
  updateFormulaQcTest(id, payload) {
    return Repository.put(`${resource}/q_c_tests/${id}`, payload)
  },
  getQcTestDetails(id) {
    return Repository.get(`${resource}/q_c_tests/${id}`)
  },
  updateFormulaProductCatalogue(id, payload) {
    return Repository.put(`${resource_single}/${id}/document`, payload)
  },

  getFormulaApplications() {
    return Repository.get(`/admin/formulation_applications`)
  },
  getFormulaApplicationDetails(id) {
    return Repository.get(`/admin/formulation_applications/${id}`)
  },
  formularApplicationUpdate(id, payload) {
    return Repository.put(`/admin/formulation_applications/${id}`, payload)
  },
  formularApplicationCreate(payload) {
    return Repository.post(`/admin/formulation_applications`, payload)
  },

  updateDangerGoodNote(id, payload) {
    return Repository.put(`${resource_single}/${id}/dangerous_goods_note`, payload)
  },
  changeFormulationPrivate(id) {
    return Repository.put(`${resource_single}/${id}/is_private`)
  },
  updateQcTestGuide(id, payload) {
    return Repository.put(`${resource}/q_c_test_guide/${id}`, payload)
  },
  updateProductSpecification(id, payload) {
    return Repository.put(`${resource_single}/${id}/product_specification`, payload)
  },
  updateProvisionalProductSpecification(id, payload) {
    return Repository.put(`${resource_single}/${id}/provisional-product-specification`, payload)
  },
  updateFormulationManufacturingFinancial(id, payload) {
    return Repository.put(`${resource_single}/${id}/manufacture_financial`, payload)
  },
  updateFormulationCustomerRelatedData(id, payload) {
    return Repository.put(`${resource_single}/${id}/customer_data`, payload)
  },
  updateFormulation(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  },

  sendProductCoaEmail(work_order_id, type, payload) {
    return Repository.post(`/admin/manufacture/work_order/${work_order_id}/send-coa-${type}-pdf`, payload)
  },
  getCompositionList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/system_setting/formulation-compositions?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCompositionDetails(id) {
    return Repository.get(`/admin/system_setting/formulation-compositions/${id}`)
  },
  createComposition(payload) {
    return Repository.post('/admin/system_setting/formulation-compositions', payload)
  },
  deleteComposition(id) {
    return Repository.delete(`/admin/system_setting/formulation-compositions/${id}`)
  },
  updateComposition(id, payload) {
    return Repository.put(`/admin/system_setting/formulation-compositions/${id}`, payload)
  },
  checkSpectOfProduct(payload) {
    return Repository.post(`/admin/customer/sample-order/check-product-spec-exists`, payload)
  },
  listOfFgPrices(payload) {
    return Repository.post(`/admin/formulations/prices`, payload)
  },
  getLinkedCustomersPricing(id) {
    return Repository.get(`/admin/formulation/${id}/pricing-linked-customers`)
  },
  getBespokeAndContracts(id, pageNumber = 1, perPage = 15) {
    return Repository.get(`admin/formulation/${id}/bespoke-and-contracts?page=${pageNumber}&per_page=${perPage}`)
  },
  getFormulationsBasedOnDilution(dilution_id) {
    return Repository.get(`${resource_single}/${dilution_id}/formulations-to-dilutions`)
  }
};
